import api from '@/api'

export default {
  /* eslint-disable no-unused-vars */
  shareItem: function ({ dispatch }, payload) {
    const {
      organizationId,
      sharedBy,
      sharedTo,
      message,
      sharedObjectId,
      sharedObjectType,
    } = payload
    const type = sharedObjectType.toLowerCase()
    return api[type].share(organizationId, {
      organizationId,
      sharedBy,
      sharedTo,
      message,
      sharedObjectId,
    })
  },

  fetchUsers: function ({ commit }, { organizationId, searchTerms, filters }) {
    const payload = {
      filters: { ...filters, isDeleted: false },
    }

    if (searchTerms) {
      payload.terms = searchTerms
    }

    return api.account
      .getAccounts(organizationId, payload)
      .then(({ data: { results } }) => {
        commit('SET_SHARE_USERS', results)
      })
      .catch(() => {
        commit('SET_SHARE_USERS', [])
      })
  },
}
